import { __assign, __rest } from "tslib";
import React from 'react';
import { CheckGroupBase } from '../internal/CheckGroupBase/CheckGroupBase';
import { CheckboxCard } from '../CheckboxCard/CheckboxCard';
import { useControlledCheckboxGroup } from '../internal/utils/useControlledCheckboxGroup';
import { forwardRefForInputGroup } from '../../internal/forwardInputGroupRef/forwardInputGroupRef';
export var CheckboxCardGroup = forwardRefForInputGroup(function (_a, ref) {
    var valuesProp = _a.values, defaultValuesProp = _a.defaultValues, nameProp = _a.name, onChange = _a.onChange, restProps = __rest(_a, ["values", "defaultValues", "name", "onChange"]);
    var getOptionProps = useControlledCheckboxGroup({
        values: valuesProp,
        defaultValues: defaultValuesProp,
        changeHandler: onChange,
        componentName: 'CheckboxCardGroup',
        nameAttribute: nameProp,
    }).getOptionProps;
    var renderOption = function (option) {
        return React.createElement(CheckboxCard, __assign({}, getOptionProps(option)));
    };
    return (React.createElement(CheckGroupBase, __assign({}, restProps, { name: nameProp, renderOption: renderOption, ref: ref })));
});
//# sourceMappingURL=CheckboxCardGroup.js.map